module.exports = __webpack_public_path__ + "img/introductionToBlockChain_sign.6c2501da.png";